<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
  <div class="container mx-auto px-4 py-8">
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-indigo-500 to-blue-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Reportes de Órdenes de Trabajo
          </h1>
          <p class="text-gray-600 mt-1">Genera reportes detallados de órdenes de trabajo</p>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      <div class="bg-gradient-to-r from-indigo-50 to-blue-50 border-b border-gray-100 p-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
          <svg class="w-5 h-5 mr-2 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
          Configuración del Reporte
        </h2>
        <p class="text-gray-600 text-sm mt-1">Seleccione los parámetros para generar el reporte</p>
      </div>

      <div class="p-6">
        <form [formGroup]="reportForm" (ngSubmit)="downloadExcelReport()">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            
            <!-- Selector de Fecha Inicio -->
            <div class="space-y-2">
              <label for="startDate" class="block text-sm font-semibold text-gray-700 flex items-center">
                <svg class="w-4 h-4 mr-1 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                Fecha Inicio *
              </label>
              <p-calendar 
                formControlName="startDate"
                [showIcon]="true"
                inputId="startDate"
                dateFormat="dd/mm/yy"
                [iconDisplay]="'input'"
                styleClass="w-full"
                inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20"
                [appendTo]="'body'"
                (onSelect)="onStartDateChange($event)"
                ></p-calendar>
            </div>

            <!-- Selector de Fecha Fin -->
            <div class="space-y-2">
              <label for="endDate" class="block text-sm font-semibold text-gray-700 flex items-center">
                <svg class="w-4 h-4 mr-1 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                Fecha Fin *
              </label>
              <p-calendar 
                formControlName="endDate"
                [showIcon]="true"
                inputId="endDate"
                dateFormat="dd/mm/yy"
                styleClass="w-full"
                [iconDisplay]="'input'"
                [appendTo]="'body'"
                inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20"
                (onSelect)="onEndDateChange($event)"
                ></p-calendar>
            </div>

            <!-- Selector de Proyectos (Múltiple) -->
            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700 flex items-center">
                <svg class="w-4 h-4 mr-1 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                Proyectos (Opcional)
              </label>
              <p-multiSelect
                formControlName="projectIds"
                [options]="projectsDropdown"
                [showClear]="true"
                [filter]="true"
                placeholder="Seleccionar proyectos"
                optionLabel="label"
                optionValue="value"
                [maxSelectedLabels]="2"
                selectedItemsLabel="{0} proyectos seleccionados"
                class="w-full custom-dropdown">
              </p-multiSelect>
            </div>

            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Tercero</label>
              <p-dropdown
                formControlName="thirdPartyId"
                [options]="thirdPartiesDropdown"
                [showClear]="true"
                [filter]="true"
                placeholder="Seleccionar tercero"
                optionLabel="label"
                optionValue="value"
                class="w-full custom-dropdown">
              </p-dropdown>
            </div>

            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Ordenante</label>
              <p-dropdown
                formControlName="payerId"
                [options]="usersDropdown"
                [showClear]="true"
                [filter]="true"
                placeholder="Seleccionar ordenante"
                optionLabel="label"
                optionValue="value"
                class="w-full custom-dropdown">
              </p-dropdown>
            </div>

            <div class="space-y-2">
              <label class="block text-sm font-semibold text-gray-700">Estado</label>
              <p-dropdown
                formControlName="status"
                [options]="statusDropdown"
                [showClear]="true"
                [filter]="true"
                placeholder="Seleccionar estado"
                optionLabel="label"
                optionValue="value"
                class="w-full custom-dropdown">
              </p-dropdown>
            </div>

            <div class="space-y-2 flex items-end">
              <div class="flex items-center space-x-2">
                <input type="checkbox" formControlName="includeCancelled" class="h-4 w-4 text-indigo-600 rounded border-gray-300" />
                <span class="text-sm text-gray-700">Incluir anuladas</span>
              </div>
            </div>
          </div>

          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
              <div>
                <span class="font-medium text-gray-600">Período:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.startDate | date:'dd/MM/yy' }} - {{ reportForm.value.endDate | date:'dd/MM/yy' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Proyectos:</span>
                <span class="ml-2 text-gray-800">{{ selectedProjectsNames }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Tercero:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.thirdPartyId || 'Todos' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Ordenante:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.payerId || 'Todos' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Estado:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.status || 'Todos' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Anuladas:</span>
                <span class="ml-2 text-gray-800">{{ reportForm.value.includeCancelled ? 'Sí' : 'No' }}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Tipo:</span>
                <span class="ml-2 text-indigo-600 font-medium">Órdenes de Trabajo</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col sm:flex-row justify-end gap-4">
            <button
              type="submit"
              [disabled]="!startDate || !endDate || loading"
              class="px-8 py-3 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold rounded-xl shadow-lg hover:from-indigo-700 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">

              <div *ngIf="loading" class="flex items-center">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
                <span>Generando Excel...</span>
              </div>

              <div *ngIf="!loading" class="flex items-center">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
                </svg>
                <span>Descargar Excel</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- My Reports Section -->
    <app-recent-report-jobs></app-recent-report-jobs>

    <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-blue-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <h4 class="text-lg font-medium text-gray-800">Información del Reporte</h4>
          <div class="mt-2 text-sm text-gray-600 space-y-1">
            <p>• Por defecto no se incluyen órdenes anuladas salvo que se active el filtro.</p>
            <p>• Se exportan campos clave: Proyecto, Tercero, Ordenante, Estado y totales.</p>
            <p>• El archivo se genera en formato Excel (.xlsx).</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


